/**
 * nhóm nhiệm vụ chi
 */
export default {
  Amount: 5,
  Text: 10,
  Date: 15,
  Boolean: 20,
  Number: 25,
  Percent: 30,
  List: 35,
};
